/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { UsersAuthzGetPermissionsCatalogQueryResponse, UsersAuthzGetPermissionsCatalog401, UsersAuthzGetPermissionsCatalog403, UsersAuthzGetPermissionsCatalog500 } from "../models/UsersAuthzGetPermissionsCatalog";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { usersAuthzGetPermissionsCatalog } from "../axios/usersAuthzGetPermissionsCatalog";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const usersAuthzGetPermissionsCatalogQueryKey = () => ["api-v2", { url: '/users-authz/v1/permissions-catalog' }] as const

export type UsersAuthzGetPermissionsCatalogQueryKey = ReturnType<typeof usersAuthzGetPermissionsCatalogQueryKey>

export function usersAuthzGetPermissionsCatalogQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = usersAuthzGetPermissionsCatalogQueryKey()
        return queryOptions<UsersAuthzGetPermissionsCatalogQueryResponse, ResponseErrorConfig<UsersAuthzGetPermissionsCatalog401 | UsersAuthzGetPermissionsCatalog403 | UsersAuthzGetPermissionsCatalog500>, UsersAuthzGetPermissionsCatalogQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return usersAuthzGetPermissionsCatalog({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns a comprehensive list of all permissions from all APIs grouped by source
 * @summary Get all available permissions across all APIs
 * {@link /users-authz/v1/permissions-catalog}
 */
export function useUsersAuthzGetPermissionsCatalog<TData = UsersAuthzGetPermissionsCatalogQueryResponse, TQueryData = UsersAuthzGetPermissionsCatalogQueryResponse, TQueryKey extends QueryKey = UsersAuthzGetPermissionsCatalogQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<UsersAuthzGetPermissionsCatalogQueryResponse, ResponseErrorConfig<UsersAuthzGetPermissionsCatalog401 | UsersAuthzGetPermissionsCatalog403 | UsersAuthzGetPermissionsCatalog500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? usersAuthzGetPermissionsCatalogQueryKey()
         

         const query = useQuery({
          ...usersAuthzGetPermissionsCatalogQueryOptions(config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<UsersAuthzGetPermissionsCatalog401 | UsersAuthzGetPermissionsCatalog403 | UsersAuthzGetPermissionsCatalog500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}